import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Label, Input, Row, Col } from 'reactstrap';
import CustomSelect from '../../../Base/Common/CustomSelect';

class ShapeInspector extends Component {
    _update = (field, value) => {
        const { element, onChange } = this.props;
        onChange({ ...element, [field]: value });
    };

    render() {
        const { element } = this.props;

        const shapeOptions = [
            { value: 'rect', label: 'Rectangle' },
            { value: 'line', label: 'Line' },
            { value: 'ellipse', label: 'Ellipse / Circle' },
            { value: 'triangle', label: 'Triangle' },
            { value: 'diamond', label: 'Diamond' },
            { value: 'star', label: 'Star' },
        ];
        // Clip-path shapes are fill-only: a border would be clipped away with the box
        const isClipShape = ['triangle', 'diamond', 'star'].includes(element.shapeType);

        return (
            <div>
                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.ShapeType" /></Label>
                        <CustomSelect
                            options={shapeOptions}
                            value={shapeOptions.find(o => o.value === element.shapeType) || shapeOptions[0]}
                            onChange={(opt) => this._update('shapeType', opt ? opt.value : 'rect')}
                        />
                    </Col>
                </Row>

                {element.shapeType !== 'line' && (
                    <Row className="mb-2">
                        <Col>
                            <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.FillColour" /></Label>
                            <Input
                                type="color"
                                value={element.fillColour || '#ffffff'}
                                onChange={(e) => this._update('fillColour', e.target.value)}
                                style={{ height: '38px', padding: '2px 4px' }}
                            />
                        </Col>
                    </Row>
                )}

                {!isClipShape && (
                    <Row className="mb-2">
                        <Col>
                            <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.BorderColour" /></Label>
                            <Input
                                type="color"
                                value={element.borderColour || '#000000'}
                                onChange={(e) => this._update('borderColour', e.target.value)}
                                style={{ height: '38px', padding: '2px 4px' }}
                            />
                        </Col>
                        <Col>
                            <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.BorderWidth" /></Label>
                            <Input
                                type="number"
                                min={0}
                                max={20}
                                value={element.borderWidth !== undefined ? element.borderWidth : 1}
                                onChange={(e) => this._update('borderWidth', parseInt(e.target.value, 10) || 0)}
                            />
                        </Col>
                    </Row>
                )}

                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.Margin" /></Label>
                        <Input
                            type="number"
                            min={0}
                            max={50}
                            value={element.margin ?? 0}
                            onChange={(e) => this._update('margin', parseFloat(e.target.value) || 0)}
                        />
                    </Col>
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.Opacity" /></Label>
                        <Input
                            type="number"
                            min={0}
                            max={100}
                            value={element.opacity ?? 100}
                            onChange={(e) => this._update('opacity', Math.max(0, Math.min(100, parseInt(e.target.value, 10) || 0)))}
                        />
                    </Col>
                </Row>

                <Row className="mb-2">
                    {(element.shapeType === 'rect' || !element.shapeType) && (
                        <Col>
                            <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.BorderRadius" /></Label>
                            <Input
                                type="number"
                                min={0}
                                max={50}
                                value={element.borderRadius ?? 0}
                                onChange={(e) => this._update('borderRadius', parseInt(e.target.value, 10) || 0)}
                            />
                        </Col>
                    )}
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}><FormattedMessage id="TemplateDesigner.Inspector.Shadow" /></Label>
                        <Input
                            type="select"
                            value={element.shadow || 'none'}
                            onChange={(e) => this._update('shadow', e.target.value)}
                        >
                            <option value="none">None</option>
                            <option value="soft">Soft</option>
                            <option value="medium">Medium</option>
                            <option value="strong">Strong</option>
                        </Input>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ShapeInspector;
